import gql from "graphql-tag";
import { GraphQlMutationBuilder } from "../../graphQL-mutation.builder";

export interface DeleteTipoDatoTableData {
  uuidTable: string;
  regDeleteId: string;
}

export class DeleteTipoDatoTableDataBuilder {
  private UUID_TABLE: string;
  private REG_DELETE_ID: string;

  private get _mutation() {
    return gql`mutation($uuidTable: String, $regDeleteId: String) {
        deleteTipoDatoTableData(td: $uuidTable, _id: $regDeleteId)       
      }`;
  }

  public withUuidTable(uuidTable: string): this {
    this.UUID_TABLE = uuidTable;
    return this;
  }

  public withRegDeleteId(regDeleteId: string): this {
    this.REG_DELETE_ID = regDeleteId;
    return this;
  }

  public build() {
    let mutationParams: DeleteTipoDatoTableData;
    const graphQlMutationBuilder: GraphQlMutationBuilder =
      new GraphQlMutationBuilder();
    mutationParams = {
      uuidTable: this.UUID_TABLE,
      regDeleteId: this.REG_DELETE_ID,
    };
    return graphQlMutationBuilder
      .withMutation(this._mutation)
      .withParams(mutationParams)
      .build();
  }
}
